import styles from './badminton.module.css'
import PersonCard from '../../../components/PersonCard/PersonCard';
import { badmintonSenioren, badmintonJunioren } from '../../../../config/mannschaftssport_teams';
import TeamCard from '../../../components/TeamCard/TeamCard';
import NewsCard from '../../../Sites/Startseite/NewsCarousel/NewsCard';
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import NoNews from '../../../components/Error/NoNews/NoNews';
import { loadAssignmentsByArea } from '../../../../code/AssignmentPersons';
import Bildergalerie from '../../../components/Bildergalerie/Bildergalerie';
function Badminton() {
    const [persons, setPersons] = useState([]);
    const [article, setArticle] = useState(null);
    const color = '--color-red';
    const colorText = '--main-color-white';

    useEffect(() => {
        loadAssignmentsByArea(10, setPersons, color, colorText);
    }, []);
    const navigate = useNavigate();
    useEffect(() => {
        fetch(`/api/news/last_news/Badminton`)
            .then(res => {
                if (!res.ok) throw new Error(`HTTP error! Status: ${res.status}${res}`);
                return res.json();
            })
            .then(data => {
                setArticle(data[0]);
            })
            .catch(err => {
                console.error("Fetch error:", err);

            });
    }, []);
    const images = [
        {
            "path": "/images/mannschaftssport/badminton/verbandsliga_1mannschaft.jpg",
            "title": "1. Mannschafts (Verbandsliga)",
            "text": "(vlnr): Joshua Saal, Niklas Neumman, Mascha Strödke, David Endtner, Hanna Becker, Sebastian Strödke",
            "subtext": "Es fehlen: Kristin Schönherr, Philip Otzipka",
            "alt": "Teamfoto der 1. Mannschaft Badminton"
        }
    ]
    return (
        <section className={styles.container}>
            <h1 id='Badminton'>Badminton</h1>
            <div className={styles.top}>

                <section className={styles.persons}>
                    <h2 id='ansprechpartner'>Ansprechpartner</h2>
                    <div>
                        {persons.map((person) => (<PersonCard person={person}></PersonCard>))}
                    </div>
                </section>
                <section className={styles.news}>
                    <h2>Letzte News</h2>
                    <div className={styles.newsInfo}>
                        {article ? (
                            <NewsCard data={article} />
                        ) : (
                            <NoNews></NoNews>
                        )}
                        <span tabIndex={0} onClick={() => navigate("/news")}
                            onKeyDown={(e) => {
                                if (e.key === "Enter" || e.key === " ") {
                                    e.preventDefault(); // Prevent space from scrolling
                                    navigate("/news")
                                }
                            }}
                        >Weitere News hier...</span>
                    </div>
                </section>
            </div>
            <section>
                <h2>Allgemeine Infos</h2>
                <div className={styles.information}>
                    <p>Badminton hat im TuS 05 Oberpleis eine lange Tradition. Seit den 1950er Jahren ging es mit unserer schönen Sportart in Oberpleis steil bergauf. In den erfolgreichsten Zeiten in den 60er und 80er Jahren spielte unsere 1.Mannschaft in der heutigen Oberliga. In den 2000er Jahren gelang sogar für eine Saison der Sprung in die Regionalliga.</p>
                    <p>Aktuell haben wir die Möglichkeit an drei Abenden in der Woche in der Sporthalle der Grundschule „Am Sonnenhügel“  zu trainieren. Zusätzlich steht uns seit dem Mai 2022 die TUS eigene Halle am Vereinsheim an Samstagen ganztägig zur freien Verfügung. Mit diesen Möglichkeiten lassen wir also keinen Wunsch nach Trainingszeiten bei unseren Mitgliedern offen. Unter anderem gehören mehrere lizensierte B- und C-Trainer zu unserem Trainerteam, die im täglichen Training von mehreren Assistenten unterstützt werden.</p>
                    <p>Im Spielbetrieb freuen wir uns, dass wir schon längerfristig mit vier Senioren Mannschaften an den Start gehen. Hier spielt unsere 1. Mannschaft in der Verbandsliga und die drei verbleibenden Mannschaften ordnen sich in den Ligen darunter ein. Im Bereich der Junioren nehmen wir regelmäßig ab der Altersklasse U11 am Ligabetrieb teil.</p>
                    <p>Wir haben für jeden, der diesen Sport mag oder sich interessiert, ein passendes Angebot. Bei den Senioren wird sowohl der Wettkampfspieler, mit unseren zahlreichen Trainingsangeboten, als auch der Freizeitspieler sehr schnell Anschluss in einer passenden Gruppe finden.</p>
                    <p>Auch im Jugendbereich gibt es für jedes Alter ab ca. 7 Jahren eine Trainingsgruppe mit qualifizierten Trainern. Wir unterstützen die Kinder und Jugendlichen darin erste Wettkampf Erfahrungen zu sammeln, indem es vielfältige Angebote von Turnieren und Mannschaftsspielen gibt. Hier freuen wir uns darüber, wenn der Badmintonsport den Ehrgeiz für sportliche Erfolge in den Kinder weckt.</p>
                    <p>Durch dieses vielfältige und umfangreiche Angebot können wir mit Stolz und Freude 180 Personen zu unserer Abteilung zählen. Dadurch sind wir einer der größten Badmintonvereine im Rhein-Sieg-Kreis.</p>
                    <p>Wenn Sie Interesse hätten, dann melden Sie sich doch gerne telefonisch oder per Email bei unseren Ansprechpartnern.</p>
                </div>

            </section>

            <section id='Trainingszeiten' className={styles.trainingszeit}>
                <h2>Trainingszeiten</h2>
                <p>Jede Trainingseinheit findet in der Turnhalle der <a href='https://maps.app.goo.gl/twkqYmkR7rWcg76P7'>Grundschule "Am Sonnenhügel"</a> statt.</p>
                <div >
                    <p className={styles.title}>Kinder (7 - 13 Jahre)</p>
                    <div>
                        <table className={`${styles.table} ${styles.tableColor}`}>
                            <tr>
                                <td>Montag</td>
                                <td>17:00 - 18:30</td>
                                <td>Sebastian, Christine und Constanze</td>
                            </tr>
                            <tr>
                                <td>Mittwoch</td>
                                <td>18:00 - 19:45</td>
                                <td>Julian</td>
                            </tr>
                        </table>
                    </div>
                </div>
                <div>
                    <p className={styles.title}>Jugendliche (13 - 18 Jahre)</p>
                    <div>
                        <table className={`${styles.table} ${styles.tableColor}`}>
                            <tr>
                                <td>Montag</td>
                                <td>18:30 - 20:00</td>
                                <td>Philip und Niklas</td>
                            </tr>
                            <tr>
                                <td>Mittwoch</td>
                                <td>18:00 - 19:45</td>
                                <td>Fabian</td>
                            </tr>
                            <tr>
                                <td>Freitag</td>
                                <td>17:00 - 18:30</td>
                                <td>Christoph und Anne</td>
                            </tr>
                        </table>
                    </div>
                </div>
                <div>
                    <p className={styles.title}>Senioren</p>
                    <div>
                        <table className={styles.tableSpec}>
                            <tr>
                                <td>
                                    <div className={styles.centerTd}><p className={styles.underline}>Wettkampfspieler</p>
                                        <table className={styles.tableSpecSmall}>
                                            <tr>
                                                <td>Montag</td>
                                                <td>20:00 - 21:45</td>
                                                <td>Philip</td>
                                            </tr>
                                            <tr>
                                                <td>Mittwoch</td>
                                                <td>19:45 - 21:45</td>
                                                <td>Fabian</td>
                                            </tr>
                                            <tr>
                                                <td>Freitag</td>
                                                <td>18:30 - 20:30</td>
                                                <td>Sebastian</td>
                                            </tr>
                                        </table></div>
                                </td>
                                <td><div className={styles.centerTd}>
                                    <p className={styles.underline}>Freizeitspieler</p>
                                    <table className={styles.tableSpecSmall}>
                                        <tr>
                                            <td>Montag</td>
                                            <td>20:00 - 21:45</td>
                                        </tr>
                                    </table></div>
                                </td>
                                <td className={styles.lastTD}>
                                    <div className={styles.centerTd}>

                                        <p className={styles.underline}>Matchtraining</p>
                                        <table className={styles.tableSpecSmall}>
                                            <tr>
                                                <td>Freitag</td>
                                                <td>18:30 - 20:30</td>
                                            </tr>
                                        </table>
                                        <p className={styles.down}>(*Wettkampf + Freizeit)</p>
                                    </div>
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>
            </section>
            <section className={styles.unsereTeams}>
                <h2>Unsere Teams</h2>
                <div className={styles.spielplanTabelle}>
                    <section>
                        <h3>Senioren:innen</h3>
                        <div className={styles.teams}>
                            {badmintonSenioren.map((item, index) => (
                                <TeamCard key={index} item={item} />
                            ))}
                        </div>
                    </section>

                    <section>
                        <h3>Junior:innen</h3>
                        <div className={styles.teamsJunior}>
                            {badmintonJunioren.map((item, index) => (
                                <TeamCard key={index} item={item} />
                            ))}
                        </div>
                    </section>
                </div>
                <section className={styles.vorstellungSec}>
                    <h3>Bildergalerie</h3>
                    <Bildergalerie images={images} />

                </section>
            </section>
        </section>
    )
}
export default Badminton;